import { useState } from "react";
import { Menu, X } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/lib/business";
import { WhatsAppIcon } from "./WhatsAppIcon";

const NAV_LINKS = [
  { href: "#inicio", label: "Início" },
  { href: "#sobre", label: "A Ótica" },
  { href: "#galeria", label: "A Loja" },
  { href: "#produtos", label: "Produtos e Serviços" },
  { href: "#exame", label: "Exame de Vista" },
  { href: "#avaliacoes", label: "Avaliações" },
  { href: "#localizacao", label: "Localização" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#inicio"
            data-testid="header-logo-link"
            className="flex items-center gap-3 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            onClick={() => setOpen(false)}
          >
            <img
              src="/assets/logo.png"
              alt="Logo da Ótica Danko"
              className="h-10 md:h-12 w-auto rounded-md"
            />
          </a>

          <nav
            data-testid="header-nav"
            className="hidden lg:flex items-center gap-8"
            aria-label="Navegação principal"
          >
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`nav-link-${link.href.slice(1)}`}
                className="text-sm font-medium text-stone-600 hover:text-brand transition-colors rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href={waLink(WA_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="header-whatsapp-button"
              className="hidden sm:inline-flex items-center gap-2 rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-brand-dark hover:shadow-md btn-motion focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
            >
              <WhatsAppIcon className="w-4 h-4" />
              Fale pelo WhatsApp
            </a>
            <button
              type="button"
              data-testid="mobile-menu-toggle"
              aria-label={open ? "Fechar menu" : "Abrir menu"}
              aria-expanded={open}
              onClick={() => setOpen(!open)}
              className="lg:hidden inline-flex items-center justify-center rounded-full w-10 h-10 text-stone-700 hover:bg-stone-100 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-stone-200 bg-white"
        >
          <nav className="px-4 py-4 flex flex-col gap-1" aria-label="Menu móvel">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`mobile-nav-link-${link.href.slice(1)}`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-4 py-3 text-base font-medium text-stone-700 hover:bg-brand-light hover:text-brand transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
              >
                {link.label}
              </a>
            ))}
            <a
              href={waLink(WA_MESSAGES.general)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-whatsapp-button"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-brand px-5 py-3 text-sm font-semibold text-white hover:bg-brand-dark transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand"
            >
              <WhatsAppIcon className="w-4 h-4" />
              Fale pelo WhatsApp
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
